/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { withStyles } from "@mui/styles";
import { Button, Dialog } from "@mui/material";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { red } from "@mui/material/colors";
import PConfirm from "./PConfirm";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: 2,
    top: 2,
    padding: 2,
    color: "#ffffff",
  },
});

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
    "&:hover": {
      backgroundColor: red[700],
    },
  },
}))(Button);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle
      disableTypography
      className={classes.root}
      {...other}
      style={{
        paddingTop: 5,
        paddingLeft: 10,
        paddingBottom: 2,
        background: "#3282b8",
        color: "#eeeeee",
      }}
    >
      <Typography variant="button" display="block">
        {children}
      </Typography>
      {onClose && !props.disableClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon
            style={{
              background: "#db0202",
            }}
          />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogContentBoderLess = withStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
    "&:first-child": {
      padding: 0,
    },
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CustomizedDialogs(props) {
  const [open, setOpen] = useState(props.open);
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    if (props.isDataChanged) {
      if (props.isDataChanged()) {
        setConfirmOpen(true);
        setConfirmContext({
          title: "Are You Sure",
          message:
            "Are you sure to close the window, All the changes will be lost",
          type: "warning",
          open: true,
          yes: true,
          no: true,
        });
      } else {
        setOpen(false);
        props.onCloseWindow();
      }
    } else {
      setOpen(false);
      props.onCloseWindow();
    }
  };

  function onYesNoClicked(context, value) {
    setConfirmOpen(false);

    if (value == "yes") {
      setOpen(false);
      props.onCloseWindow();
    }
  }

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        onKeyDown={props.onKeyDown}
        onKeyPress={props.onKeyPress}
        onKeyUp={props.onKeyUp}
        maxWidth={props.maxWidth}
        fullWidth={props.fullWidth}
        disableBackdropClick={true}
        disableEscapeKeyDown={false}
        fullScreen={props.fullScreen ? props.fullScreen : false}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            props.onCloseWindow();
          }
        }}
      >
        {props.title && (
          <DialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
            disableClose={props.disableClose}
          >
            {props.title}
          </DialogTitle>
        )}
        {props.isLoaderEnabled && <LinearProgress />}
        {!props.borderLess && (
          <DialogContent
            style={{ overflow: props.overFlow ? props.overFlow : "auto" }}
            dividers
          >
            {props.content}
          </DialogContent>
        )}
        {props.borderLess && (
          <DialogContentBoderLess dividers>
            {props.content}
          </DialogContentBoderLess>
        )}
        {(!props.borderLess || props.withActions) && (
          <DialogActions>
            {props.showLeftButton && (
              <Button
                onClick={props.onLeftButtonCLicked}
                variant="contained"
                color="primary"
              >
                {props.leftButtonLabel}
              </Button>
            )}
            {props.onDelete && props.mode == "edit" && (
              <ColorButton onClick={props.onDelete} variant="outlined">
                Delete
              </ColorButton>
            )}
            {props.removeSelected && (
              <ColorButton onClick={props.onRemoveSelected} variant="outlined">
                Remove Selected
              </ColorButton>
            )}
            <div style={{ flex: "1 0 0" }} />
            {!props.hideSave && props.mode != "view" && (
              <Button
                onClick={props.onSave}
                variant="contained"
                color="primary"
                disabled={
                  props.isLoaderEnabled ? true : false || props.saveDisabled
                }
              >
                {props.isSaveLoaderEnabled && (
                  <CircularProgress
                    size={20}
                    style={{ color: "#31e85c", marginRight: "10px" }}
                  />
                )}
                {props.saveLabel ? props.saveLabel : "Save"}
              </Button>
            )}
            {props.showPrint && (
              <Button
                onClick={props.onPrint}
                variant="contained"
                color="primary"
              >
                {props.printLabel ? props.printLabel : "Save & Print"}
              </Button>
            )}
            {props.showChequePrint && (
              <Button
                onClick={props.onChequePrint}
                variant="contained"
                color="primary"
              >
                {props.printLabel ? props.printLabel : "Print Cheque"}
              </Button>
            )}
            {props.showNew && (
              <Button
                onClick={props.onNewClicked}
                variant="contained"
                color="primary"
              >
                New
              </Button>
            )}
            {props.showSaveDraftButton && (
              <Button
                onClick={props.onSaveDraftClicked}
                variant="contained"
                color="primary"
              >
                Save Draft
              </Button>
            )}
          </DialogActions>
        )}
      </Dialog>
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
